import SeparatorhorCommon from './containers/separatorhorCommon'

export {default as SeparatorhorCommonLayout} from './components/separatorhorCommonLayout'

export default SeparatorhorCommon
